import React from "react";
import Lottie from "lottie-react";
import loadingAnimation from "../assets/loader.json";

const Loader = ({ style = { width: 100, height: 100 }, animationData = loadingAnimation, ...props }) => (
  <Lottie
    animationData={animationData}
    loop={true}
    style={style}
    {...props}
  />
);

export default Loader; 